import React from "react";
import Card from "./Card";
import productsData from "../data/products.json";
import { productImage } from "../data/productImages";
import BookCTA from "./BookCTA";
import { analytics } from "../analytics";
import "./ProductsSection.css";

/* Same products.json, same UTM'd outbound links, same tags. */
const ProductsSection = () => (
  <section
    id="products"
    className="section products"
    style={{ "--section-bg": "var(--bg-primary)" }}
  >
    <div className="container">
      <div className="section-header">
        <p className="eyebrow">Featured Products</p>
        <h2>Build Specialized AI Products</h2>
        <p className="section-sub">
          Products we design, engineer, and operate from first release to
          production scale.
        </p>
        <BookCTA
          ctaLocation="products_section"
          source="products"
          className="link-arrow products-cta"
        >
          Learn more about our products <span className="arrow">→</span>
        </BookCTA>
      </div>

      <div className="products-grid">
        {productsData.map((product) => (
          <Card
            key={product.id}
            title={product.title}
            description={product.description}
            image={product.image}
            fallbackImage={productImage(product.slug)}
            link={{ href: product.url, label: "Visit Product →" }}
            onLinkClick={() =>
              analytics.outboundProductClick({
                product: product.slug,
                product_title: product.title,
              })
            }
            tag={product.label}
            tagType={product.type}
            className="card--product"
          />
        ))}
      </div>
    </div>
  </section>
);

export default ProductsSection;
